import $ from 'jquery';

const getNextImage = ($target) => {
  return $target.next().find('img[data-srcset]');
};

const getPreviousImage = ($target) => {
  return $target.prev().find('img[data-srcset]');
};

export const init = (carouselId) => {
  $('#' + carouselId).on('slide.bs.carousel', (e) => {
    const $target = $(e.relatedTarget);
    const $img = e.direction === 'left' ? getNextImage($target) : getPreviousImage($target);
    const data = $img.data('srcset');

    if (typeof data !== 'undefined') {
      $img.attr('srcset', data).removeAttr('data-srcset');
      window.picturefill($img);
    }
  });
};
